import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-editor" }
const _hoisted_2 = {
  key: 0,
  class: "text-editor__menu-bar"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "15",
  viewBox: "0 0 10 15",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.16801 13.7962L7.10698 11.6962L5.84854 10.4074C5.59212 10.1465 5.24458 10 4.88223 10C4.51988 10 4.17234 10.1465 3.91592 10.4074L0.590031 13.7962C0.153427 14.2411 0.468038 15 1.078 15H8.68004C9.29642 15 9.60461 14.2411 9.16801 13.7962Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.6783 0H1.0791C0.46295 0 0.154874 0.758914 0.591314 1.20379L3.91596 4.59274C4.44868 5.13575 5.31514 5.13575 5.84786 4.59274L7.11225 3.30389L9.17251 1.20379C9.60253 0.758914 9.29445 0 8.6783 0Z" })
], -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "15",
  viewBox: "0 0 10 15",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.16801 13.7962L7.10698 11.6962L5.84854 10.4074C5.59212 10.1465 5.24458 10 4.88223 10C4.51988 10 4.17234 10.1465 3.91592 10.4074L0.590031 13.7962C0.153427 14.2411 0.468038 15 1.078 15H8.68004C9.29642 15 9.60461 14.2411 9.16801 13.7962Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.6783 0H1.0791C0.46295 0 0.154874 0.758914 0.591314 1.20379L3.91596 4.59274C4.44868 5.13575 5.31514 5.13575 5.84786 4.59274L7.11225 3.30389L9.17251 1.20379C9.60253 0.758914 9.29445 0 8.6783 0Z" })
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

import { onMounted, ref, watch } from 'vue'
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import FontFamily from '@tiptap/extension-font-family'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import Strike from '@tiptap/extension-strike'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    value: {},
    setValue: { type: Function }
  },
  setup(__props: any) {

const props = __props
const editor = ref<Editor>()
const selectedFont = ref<string>('Inter')
const selectedSize = ref<number>(2)
const isFontSizeSelectOpen = ref<boolean>(false)
const isFontFamilySelectOpen = ref<boolean>(false)

onMounted(() => {
  editor.value = new Editor({
    extensions: [
      TextStyle,
      FontFamily,
      StarterKit,
      Underline,
      Strike
    ],
    content: `<p>${props.value ?? ''}</p>`,
    onUpdate: () => {
      props.setValue(editor.value!.getHTML())
    }
  })
  editor.value.chain().focus().toggleHeading({ level: 2 }).run()
  editor.value.chain().focus().setFontFamily('Inter').run()
})

watch(() => props.value, (newValue) => {
  if (editor.value && newValue !== editor.value.getHTML()) {
    editor.value.commands.setContent(newValue ?? '')
  }
})

const fonts = [
  'Sans-serif',
  'Inter',
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Verdana',
  'Tahoma',
  'Garamond',
  'Palatino',
  'Bookman',
  'Comic Sans MS',
  'Trebuchet MS',
  'Arial Black',
  'Impact',
  'Lucida Console'
]

const closeSelect = (select: string) => {
  setTimeout(() => {
    if (select == 'font-size') {
      isFontSizeSelectOpen.value = false
    } else if (select == 'font-family') {
      isFontFamilySelectOpen.value = false
    }
  }, 80)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (editor.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["font mySelect", {open: isFontSizeSelectOpen.value}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => {isFontSizeSelectOpen.value = !isFontSizeSelectOpen.value;}),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (closeSelect('font-size')))
          }, [
            _createTextVNode(_toDisplayString(`H${selectedSize.value}` ?? 'Normal') + " ", 1),
            _hoisted_3,
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], (level, index) => {
                  return _createElementVNode("li", {
                    key: index,
                    onClick: ($event: any) => {selectedSize.value = level; editor.value.chain().focus().toggleHeading({ level: level }).run()},
                    class: _normalizeClass({ 'is-active': editor.value.isActive('heading', { level: level }) })
                  }, "H" + _toDisplayString(level), 11, _hoisted_4)
                }), 64))
              ])
            ])
          ], 34),
          _createElementVNode("button", {
            class: _normalizeClass(["font mySelect", {open: isFontFamilySelectOpen.value}]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => {isFontFamilySelectOpen.value = !isFontFamilySelectOpen.value;}),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (closeSelect('font-family')))
          }, [
            _createTextVNode(_toDisplayString(selectedFont.value) + " ", 1),
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fonts, (font, index) => {
                  return _createElementVNode("li", {
                    key: index,
                    onClick: ($event: any) => {selectedFont.value = font; editor.value.chain().focus().setFontFamily(font).run()},
                    class: _normalizeClass({ 'is-active': editor.value.isActive('textStyle', { fontFamily: font }) })
                  }, _toDisplayString(font), 11, _hoisted_6)
                }), 64))
              ])
            ])
          ], 34),
          _createElementVNode("button", {
            class: _normalizeClass(["bold", { 'is-active': editor.value.isActive('bold') }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (editor.value.chain().focus().toggleBold().run())),
            disabled: !editor.value.can().chain().focus().toggleBold().run()
          }, " B ", 10, _hoisted_7),
          _createElementVNode("button", {
            class: _normalizeClass(["italic", { 'is-active': editor.value.isActive('italic') }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (editor.value.chain().focus().toggleItalic().run())),
            disabled: !editor.value.can().chain().focus().toggleItalic().run()
          }, " I ", 10, _hoisted_8),
          _createElementVNode("button", {
            class: _normalizeClass(["underline", { 'is-active': editor.value.isActive('underline') }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (editor.value.chain().focus().toggleUnderline().run())),
            disabled: !editor.value.can().chain().focus().toggleUnderline().run()
          }, " U ", 10, _hoisted_9),
          _createElementVNode("button", {
            class: _normalizeClass(["strike-through", { 'is-active': editor.value.isActive('strike') }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (editor.value.chain().focus().toggleStrike().run())),
            disabled: !editor.value.can().chain().focus().toggleStrike().run()
          }, " S ", 10, _hoisted_10)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(EditorContent), {
      class: "text-editor--input",
      editor: editor.value
    }, null, 8, ["editor"])
  ]))
}
}

})